module.exports = __webpack_public_path__ + "img/sld_scb_7_t1_dark.4600b6d2.svg";